<dt-table-layout *dtDataLoad="videoCategories != null; error: hasError">
  <div header class="cp-filters-form">
    <button mat-raised-button color="primary" (click)="addCategory()"
      ><mat-icon>add</mat-icon><ng-container i18n>Themengebiet hinzufügen</ng-container></button
    >
  </div>

  <table mat-table [dataSource]="videoCategories" cdkDropList (cdkDropListDropped)="categoryDrop($event)">
    <ng-container matColumnDef="drag">
      <th mat-header-cell *matHeaderCellDef></th>
      <td mat-cell *matCellDef="let row">
        <mat-icon class="indicator-drag-handle" cdkDragHandle>drag_handle</mat-icon>
      </td>
    </ng-container>
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef i18n>Name</th>
      <td mat-cell *matCellDef="let row">{{ row.name }}</td>
    </ng-container>
    <ng-container matColumnDef="videoCount">
      <th mat-header-cell *matHeaderCellDef i18n>Anzahl von Videos</th>
      <td mat-cell *matCellDef="let row">{{ row.videoCount }}</td>
    </ng-container>
    <ng-container matColumnDef="updatedAt">
      <th mat-header-cell *matHeaderCellDef i18n>Aktualisiert am</th>
      <td mat-cell *matCellDef="let row">{{ row.updatedAt | date: 'medium' }}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
    <tr
      mat-row
      cdkDrag
      cdkDragLockAxis="y"
      *matRowDef="let row; columns: displayedColumns"
      (click)="$event.defaultPrevented || showDetails(row)"
    ></tr>

    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="displayedColumns.length" i18n>Keine Projekte entsprechen dem Filter.</td>
    </tr>
  </table>

  <dt-table-footer [visibleCount]="videoCategories.length" [totalCount]="videoCategories.length"></dt-table-footer>
</dt-table-layout>
